import { useCallback } from 'react';
import WaveSurfer from 'wavesurfer.js';
import { WaveSurferRef } from './types';

export const usePlayPause = (waveSurferRef: WaveSurferRef): WaveSurfer['playPause'] => {
  return useCallback(async () => waveSurferRef.current?.playPause(), [waveSurferRef]);
};
